import { Theme } from '@material-ui/core';

const styles = (theme: Theme) => {
  const {
    custom: {
      palette: { colorSupportSteel, colorSupportPowder, colorSupportMidnight },
    },
    palette: {
      common: { white },
    },
    spacing: { unit },
    zIndex: { drawer },
  } = theme;

  return {
    helpCenter: {
      display: 'inline-block',
      float: 'right',
      margin: `${unit}px 0px`,
    },
    logo: {
      maxWidth: 113,
      width: '100%',
      maxHeight: 60,
    },
    logoWrapper: {
      borderBottom: 'none',
      height: 45,
      minWidth: 216,
      padding: `${unit / 2}px ${unit * 10 - 1}px ${unit / 2}px ${unit * 2}px`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'start',
    },
    root: {
      zIndex: drawer,
      backgroundColor: white,
      borderBottom: `1px solid ${colorSupportPowder}`,
      display: 'inline-flex',
      height: 60,
      width: '100%',
      alignItems: 'center',
      paddingRight: unit * 3,
    },
    dark: {
      backgroundColor: colorSupportMidnight,
    },
    tooltip: {
      backgroundColor: `${colorSupportSteel} !important`,
      fontWeight: 500,
      textAlign: 'center !important',
    },
  };
};

export default styles;
